interface ContextType {
    name: string;
    route: any;
}

let contextType: ContextType = {
    name: '',
    route: null
};

export function getContextType(): ContextType {
    return contextType;
}

export function setContextType(context: Partial<ContextType>): void {
    if (!context || typeof context !== 'object') {
        console.warn('【zp-weblog】setContextType: 无效的 context 参数');
        return;
    }

    if (!context.name) {
        console.warn('【zp-weblog】setContextType: context 缺少 name 属性');
        return;
    }
    contextType = { ...contextType, ...context };
}
